import React, {FC} from 'react';

import {Anchor} from '../../../../../libs/shared/ui/src/components/reposition/repositionHelpers';
import {useAppDispatch} from '../../../../helpers/appReduxHelpers';
import {SandboxScenariosEnum} from '../../../../helpers/sandbox/sandboxScenarioHelpers';
import {navigateToSandboxChatDemoAsyncAction} from '../../../../store/data/teammates/teammatesActions';
import {AnalyticsMoreEducationTip} from './analyticsMoreEducationTip';
import {SandboxEducationTipCoordinator, useSandboxEndDemoHandler} from './sandboxEducationTipCoordinator';

/*
 * Props.
 */

interface AnalyticsMoreEducationTipCoordinatorProps {
  anchor: Anchor;
  conversationId: number | undefined;
}

/*
 * Component.
 */

export const AnalyticsMoreEducationTipCoordinator: FC<AnalyticsMoreEducationTipCoordinatorProps> = (
  props,
) => {
  const dispatch = useAppDispatch();
  const onEndDemo = useSandboxEndDemoHandler();

  // We want to kick off the live chat demo before archiving the analytics demo conversation.
  const onBeforeNext = async () => {
    await dispatch(navigateToSandboxChatDemoAsyncAction());
  };

  return (
    <SandboxEducationTipCoordinator
      anchor={props.anchor}
      conversationId={props.conversationId}
      scenario={SandboxScenariosEnum.SCENARIO3_ACT3}
      step="complete-demo"
      isEligible
      renderEducationTip={(tipProps) => <AnalyticsMoreEducationTip {...tipProps} />}
      onBeforeNext={onBeforeNext}
      onEnd={onEndDemo}
    />
  );
};
